export default {
  selectDateRange: "Select Date Range",
  start: "Start",
  end: "End",
};
